import React, { Component } from 'react';

import VirtualizedList from '../VirtualizedList';
import { appsPerPage, clocksPerPage } from 'config';
import App from '../../../models/app';
import { AppRow, ITEMS_PER_ROW } from './AppRow';
import { AppType } from '../../../constants';

interface AppDigestProps {
  onRemove?: () => void;
  showInstalled?: boolean;
  showUpdate?: boolean;
  showSettings?: boolean;
}

interface VirtualizedAppListProps {
  apps: App[];
  hasNextPage: boolean;
  appDigestProps?: AppDigestProps;
  fetchMore: any;
  navbarHeight: number;
  collectionId?: string;
  appType: AppType;
  listHeader?: React.ReactNode;
}

export class VirtualizedAppList extends Component<VirtualizedAppListProps> {
  isItemLoaded = ({ index }: { index: number }) => {
    const { apps, appType } = this.props;
    const isTile = appType === AppType.TILE;

    if (isTile) {
      return !!apps[index];
    }

    return !!apps[index * ITEMS_PER_ROW];
  };

  fetchMore = ({ startIndex }: { startIndex: number }): any => {
    const { fetchMore, appType } = this.props;
    if (!fetchMore) return;

    const isTile = appType === AppType.TILE;
    if (isTile) {
      return fetchMore({ startIndex });
    }

    return fetchMore({ startIndex: startIndex * ITEMS_PER_ROW });
  };

  render() {
    const { apps, hasNextPage, navbarHeight, collectionId, appType, listHeader } = this.props;
    const isTile = appType === AppType.TILE;

    const itemsCount = isTile
      ? apps.length
      : Math.ceil(apps.length / ITEMS_PER_ROW);

    const perPage = appType === AppType.CLOCK ? clocksPerPage : appsPerPage;
    const pageSize = isTile ? perPage : Math.ceil(perPage / ITEMS_PER_ROW);

    return (
      <VirtualizedList
        isApp={true}
        currentCount={itemsCount}
        maxCount={!hasNextPage ? itemsCount : undefined}
        pageSize={pageSize}
        pageLoadThreshold={8}
        isItemLoaded={this.isItemLoaded}
        fetchMore={this.fetchMore}
        navbarHeight={navbarHeight}
        listHeader={listHeader}
      >
        {({ index }: any) => (
          <AppRow
            index={index}
            apps={apps}
            collectionId={collectionId}
            appType={appType}
          />
        )}
      </VirtualizedList>
    );
  }
}
